<template>
  <div class="page-container" v-wechat-title="titleTop">
    <!-- 顶部状态栏占位 -->
    <div class="status-bar-placeholder"></div>

    <main class="main-content">
      
      <!-- 1. 顶部潜水员身份卡 -->
      <div class="identity-card" @click="onUserInfo">
        <img 
          :src="userData && userData.icon ? userData.icon : '/img/defaultIcon.jpg'" 
          class="id-avatar" 
          alt="Avatar"
        />
        <div class="id-info">
          <!-- 用户名 -->
          <div class="id-name">{{ userData ? userData.nickName : '未登录' }}</div>
          <!-- 等级/头衔 -->
          <div class="id-level-badge">
            <van-icon name="medal-o" class="level-icon"></van-icon>
            {{ userLevelLabel }}
          </div>
        </div>
      </div>

      <!-- 2. 模块：我的行程 -->
      <div class="dashboard-module">
        <div class="module-header">
          <van-icon name="map-marked" color="#0057FF" size="18"></van-icon>
          <h3 class="module-title">我的行程</h3>
        </div>
        
        <div class="module-content">
          <div v-if="tripList.length > 0" class="trip-highlight" @click="onTrip(tripList[0])">
            <span class="trip-status">{{ GetEnumText('Em_LearningState', tripList[0].state) }}</span>
            <h2 class="trip-name">{{ tripList[0].title }}</h2>
            <div class="trip-time">
              <van-icon name="clock-o"></van-icon>
              {{ tripList[0].about || '暂无时间详情' }}
            </div>
          </div>
          <div v-else class="empty-state">暂无待开始的行程</div>
        </div>

        <div class="module-footer">
          <button class="action-btn btn-secondary" @click="onTripList">
            查看全部行程
            <van-icon name="arrow"></van-icon>
          </button>
        </div>
      </div>

      <!-- 3. 模块：潜水日志 (重点修复区域) -->
      <div class="dashboard-module">
        <div class="module-header">
          <van-icon name="notes-o" color="#0057FF" size="18"></van-icon>
          <h3 class="module-title">潜水日志</h3>
        </div>
        
        <div class="module-content">
          <div v-if="divelogList.length > 0" class="log-grid" @click="onClickDiveLog(divelogList[0].diveLogId)">
            <div class="log-left">
              <span class="log-loc">
                {{ divelogList[0].country }} {{ divelogList[0].divePlaceName ? divelogList[0].divePlaceName : divelogList[0].divePlaceNameEng }}
              </span>
              <span class="log-sub">
                {{ formatDate(divelogList[0].dateOfStar, "yyyy.MM.dd") }} · 第 {{ divelogList[0].diveNum }} 潜
              </span>
            </div>
            <!-- 右侧统计数据 -->
            <div class="log-right">
              <div class="stat-group">
                <!-- 修复：使用 formatStat 去除 .0，并应用 DIN 字体 -->
                <h4>{{ formatStat(divelogList[0].maxDeep) }}m</h4>
                <span>深度</span>
              </div>
              <div class="stat-group">
                <!-- 修复：使用 formatStat 去除 .0，并应用 DIN 字体 -->
                <h4>{{ formatStat(divelogList[0].dateOfLen) }}min</h4>
                <span>时长</span>
              </div>
            </div>
          </div>
          <div v-else class="empty-state">暂无日志记录</div>
        </div>

        <div class="module-footer">
          <button class="action-btn btn-secondary" @click="onClickDiveLog(undefined)">
            我的日志本
            <van-icon name="arrow"></van-icon>
          </button>
        </div>
      </div>

      <!-- 4. 模块：AI 教练 -->
      <div class="dashboard-module">
        <div class="module-header">
          <van-icon name="chat-o" color="#0057FF" size="18"></van-icon>
          <h3 class="module-title">AI 教练</h3>
        </div>
        
        <div class="module-content">
          <div class="ai-preview">
            <div class="ai-avatar">
              <van-icon name="smile-o" size="24"></van-icon>
            </div>
            <div class="ai-desc">
              基于您的 <strong>{{ totalLogCount }}</strong> 条日志数据，<br>为您提供专业的潜水分析与建议。
            </div>
          </div>
        </div>

        <div class="module-footer">
          <button class="action-btn btn-primary" @click="onAiCoach">
            开始咨询
            <van-icon name="chat-o"></van-icon>
          </button>
        </div>
      </div>

    </main>

    <!-- 5. 底部导航栏 -->
    <van-tabbar v-model="activeTab" active-color="#0057FF" inactive-color="#9CA3AF" fixed placeholder>
      <van-tabbar-item icon="shop-o" @click="onTabClick('dive')">潜水</van-tabbar-item>
      <van-tabbar-item icon="description" @click="onTabClick('cert')">证书</van-tabbar-item>
      <van-tabbar-item icon="manager" @click="onTabClick('my')">我的</van-tabbar-item>
    </van-tabbar>

    <bindPhone v-model="showBindPhone" show-type="reg" @finish="onBindPhoneFinish" />
    <NativeBar ref="menu" v-model="NativeBarId" />
  </div>
</template>

<script>
import request from '@/utils/request'
import { Icon, Button, Tabbar, TabbarItem, Toast } from 'vant'
import { getUrlKey, GetEnumText, formatDate, getUserBase } from '@/utils/base'
import { GetDiveTitle } from '@/utils/base'
import bindPhone from '@/components/bindPhone'
import NativeBar from '@/components/NativeBar'

export default {
  name: 'DiveHome',
  components: {
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Toast.name]: Toast,
    bindPhone,
    NativeBar
  },
  data() {
    return {
      NativeBarId: 'dive',
      activeTab: 0,
      titleTop: '',
      userData: null,
      tripList: [],
      divelogList: [],
      showBindPhone: false,
      checkReg: false
    }
  },
  computed: {
    userLevelLabel() {
      if (!this.userData) return '游客'
      if (this.userData.proName) return this.userData.proName
      if (this.userData.vipLevelName) return this.userData.vipLevelName
      return '潜水员'
    },
    totalLogCount() {
      if (this.divelogList && this.divelogList.length > 0) {
        return this.divelogList[0].diveNum || 0
      }
      return 0
    }
  },
  activated() {
    this.activeTab = 0
    this.initData()
    this.NativeBarId = ''
    setTimeout(() => {
      this.NativeBarId = 'dive'
    }, 1)
  },
  created() {
    this.titleTop = GetDiveTitle()
    const checkReg = getUrlKey('reg')
    this.checkReg = !!checkReg
    
    getUserBase(data => {
      this.userData = data
      if (this.checkReg && !data.bindPhone) {
        this.showBindPhone = true
        this.checkReg = false
      }
    }, true)

    this.initData()

    this.NativeBarId = ''
    setTimeout(() => {
      this.NativeBarId = 'dive'
    }, 1)
  },
  methods: {
    GetEnumText,
    formatDate,
    
    // --- 核心修复：数字格式化函数 ---
    formatStat(val) {
      if (val === undefined || val === null || val === '') return '-'
      // parseFloat 会自动去除末尾的 .0 (例如 40.0 -> 40)
      return parseFloat(val).toString()
    },

    initData() {
      this.loadTripList()
      this.loadDiveLogList()
    },

    loadTripList() {
      request({
        url: '/DiveTrip/GetDiveTripHome',
        method: 'post'
      }).then(response => {
        if (response.success) {
          this.tripList = response.data.rows
        }
      })
    },

    loadDiveLogList() {
      request({
        url: '/Dive/getDiveLogHomeList',
        method: 'post'
      }).then(response => {
        if (response.success) {
          this.divelogList = response.data
        }
      })
    },

    onUserInfo() {
      this.$router.push('/my/index')
    },
    onTripList() {
      this.$router.push('/divetrip')
    },
    onTrip(item) {
      if (item && item.studentId) {
        this.$router.push('/divetrip/trip/' + item.studentId)
      }
    },
    onClickDiveLog(id) {
      if (id) {
        this.$router.push('/dive/log/' + id)
      } else {
        this.$router.push('/dive/logList')
      }
    },
    onAiCoach() {
      Toast('AI 教练功能正在开发中，敬请期待')
    },
    onBindPhoneFinish() {
      this.loadTripList()
    },
    onTabClick(type) {
      if (type === 'dive') {
        // 当前页
      } else if (type === 'cert') {
        this.$router.push('/my/myCerificate')
      } else if (type === 'my') {
        this.$router.push('/my/index')
      }
    }
  }
}
</script>

<style scoped>
/* --- 全局样式 --- */
.page-container { 
  min-height: 100vh; 
  background-color: #F9FAFB; 
  padding-bottom: 80px; 
  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, sans-serif;
  color: #374151;
}
.status-bar-placeholder { height: 20px; }
.main-content { padding: 16px; max-width: 480px; margin: 0 auto; }

/* --- 顶部潜水员身份卡 --- */
.identity-card {
  background: white;
  border-radius: 16px;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.03);
  margin-bottom: 24px;
}

.id-avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: 2px solid #EFF6FF;
  object-fit: cover;
  flex-shrink: 0;
}

.id-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.id-name {
  font-size: 18px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 6px 0;
  line-height: 1.2;
}

.id-level-badge {
  display: inline-flex;
  align-items: center;
  background: linear-gradient(90deg, #0057FF 0%, #2563EB 100%);
  color: white;
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: 500;
  width: fit-content;
}

.level-icon { margin-right: 4px; font-size: 12px; }

/* --- Dashboard 通用模块 --- */
.dashboard-module {
  background: white;
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.03); 
  margin-bottom: 24px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.module-header {
  padding: 20px 20px 10px 20px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.module-title {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  margin: 0;
}

.module-content {
  padding: 0 20px 20px 20px;
  flex: 1;
}

.module-footer {
  padding: 12px 20px 16px 20px;
  border-top: 1px solid #F3F4F6;
  background: #FAFAFA;
}

/* --- 按钮样式 --- */
.action-btn {
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: opacity 0.2s;
  outline: none;
}
.action-btn:active { opacity: 0.8; }

.btn-secondary {
  background-color: white;
  color: #0057FF;
  border: 1px solid #EFF6FF;
  box-shadow: 0 2px 5px rgba(0, 87, 255, 0.05);
}
.btn-primary {
  background: linear-gradient(135deg, #0057FF 0%, #2563EB 100%);
  color: white;
  box-shadow: 0 4px 10px rgba(0, 87, 255, 0.2);
}

/* --- 模块：行程 --- */
.trip-highlight { margin-top: 8px; cursor: pointer; }
.trip-status {
  display: inline-block;
  font-size: 11px;
  color: #0057FF;
  background: #EFF6FF;
  padding: 2px 8px;
  border-radius: 4px;
  margin-bottom: 8px;
  font-weight: 500;
}
.trip-name { font-size: 20px; font-weight: 600; color: #1F2937; margin: 0 0 6px 0; }
.trip-time { font-size: 13px; color: #6B7280; display: flex; align-items: center; gap: 4px; }

/* --- 模块：日志 --- */
.log-grid { display: flex; justify-content: space-between; align-items: center; margin-top: 10px; cursor: pointer; }
.log-left { display: flex; flex-direction: column; }
.log-loc { font-size: 18px; color: #1F2937; font-weight: 600; margin-bottom: 4px; }
.log-sub { font-size: 12px; color: #9CA3AF; }
.log-right { display: flex; gap: 20px; text-align: right; }

/* 重点修复：数字字体样式 */
.stat-group h4 { 
  font-size: 20px; 
  color: #111827; 
  margin: 0; 
  /* 强制使用 DIN 字体，匹配 React 设计 */
  font-family: 'DIN Alternate', -apple-system, sans-serif; 
  font-weight: 500; 
}
.stat-group span { font-size: 10px; color: #9CA3AF; }

/* --- 模块：AI --- */
.ai-preview { display: flex; align-items: center; gap: 16px; margin-top: 8px; }
.ai-avatar { 
  width: 48px; 
  height: 48px; 
  border-radius: 50%; 
  background: #EFF6FF; 
  display: flex; 
  align-items: center; 
  justify-content: center; 
  color: #0057FF; 
}
.ai-desc { font-size: 13px; color: #6B7280; line-height: 1.5; }

.empty-state { color: #D1D5DB; font-size: 13px; padding: 10px 0; }
</style>